export enum SlideDuration {
  Unknown = 0,
  Short = 1,
  Medium = 2,
  Long = 3
}
